import React from 'react'
import { Button, Flex } from '@workwhile/ui'
import { FormProvider, useForm } from 'react-hook-form'
import { IntFilter } from 'components/Filter/IntFilter'
import { SelectFilter } from 'components/Filter/SelectFilter'
import { StringFilter } from 'components/Filter/StringFilter'
import { useNotificationTasksContextValue } from '../context/NotificationTasksProvider'

type NotificationTaskFiltersForm = {
  id: number | null
  status: string[]
  eventName: string[]
  search: string
}

const eventNameOptions = [
  'UNIFIED_FUNDS_TRANSFER_INITIATED_EVENT',
  'UNIFIED_FUNDS_TRANSFER_COMPLETED_EVENT',
  'UNIFIED_FUNDS_TRANSFER_FAILED_EVENT',
  'ORIGINATED_ACH_TRANSFER_CANCELED',
  'ORIGINATED_ACH_TRANSFER_FAILED',
  'ORIGINATED_ACH_TRANSFER_INITIATED',
  'ORIGINATED_ACH_TRANSFER_PENDING',
  'ORIGINATED_ACH_TRANSFER_PROCESSED',
  'ORIGINATED_ACH_TRANSFER_PROCESSING',
  'ORIGINATED_ACH_TRANSFER_RETURNED',
  'NON_ORIGINATED_ACH_TRANSFER_RECEIVED',
  'NON_ORIGINATED_ACH_TRANSFER_PROCESSED',
  'NON_ORIGINATED_ACH_TRANSFER_FAILED',
  'NON_ORIGINATED_ACH_TRANSFER_RETURNED',
  'NOTIFICATION_ACTIVATION',
].map((value) => ({ label: value, value }))

const statusOptions = [
  { label: 'Created', value: 'created' },
  { label: 'Failed', value: 'failed' },
  { label: 'Attempted', value: 'attempted' },
  { label: 'Invalid Payload', value: 'invalid_payload' },
]

export const NotificationTasksFilterBar = () => {
  const {
    state: { filters },
    actions: { setFilters },
  } = useNotificationTasksContextValue()

  const methods = useForm<NotificationTaskFiltersForm>({
    values: {
      id: filters.id,
      status: filters.status,
      eventName: filters.eventName,
      search: filters.search,
    },
  })

  return (
    <FormProvider {...methods}>
      <Flex
        as="form"
        flexDirection="row"
        flexWrap="wrap"
        gap={2}
        alignItems="center"
        onSubmit={methods.handleSubmit((data) => setFilters(data))}
      >
        <IntFilter<NotificationTaskFiltersForm>
          fieldPath="id"
          label="ID"
          filterKey="id"
          inputLabel="ID"
        />
        <SelectFilter<NotificationTaskFiltersForm, string>
          fieldPath="status"
          label="Status"
          filterKey="status"
          options={statusOptions}
        />
        <SelectFilter<NotificationTaskFiltersForm, string>
          fieldPath="eventName"
          label="Event name"
          filterKey="event-name"
          options={eventNameOptions}
        />
        <StringFilter<NotificationTaskFiltersForm>
          fieldPath="search"
          label="Payload"
          filterKey="search"
          inputLabel="text in the payload"
        />
        <Button type="submit" variant="primary">
          Search
        </Button>
      </Flex>
    </FormProvider>
  )
}
